import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rpe-vista-datos-mi-empresa-container',
  templateUrl: './vista-datos-mi-empresa-container.component.html',
  styleUrls: ['./vista-datos-mi-empresa-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VistaDatosMiEmpresaContainerComponent {
  
}
